namespace RioERP.Orders {
    export namespace TeacherPaymentsService {
        export const baseUrl = 'Orders/TeacherPayments';

        export declare function Create(request: Serenity.SaveRequest<TeacherPaymentsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TeacherPaymentsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TeacherPaymentsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TeacherPaymentsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetTeacherTotalShare(request: FranchiseePayoutRequest, onSuccess?: (response: FranchiseePayoutResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/TeacherPayments/Create",
            Update = "Orders/TeacherPayments/Update",
            Delete = "Orders/TeacherPayments/Delete",
            Retrieve = "Orders/TeacherPayments/Retrieve",
            List = "Orders/TeacherPayments/List",
            GetTeacherTotalShare = "Orders/TeacherPayments/GetTeacherTotalShare"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetTeacherTotalShare'
        ].forEach(x => {
            (<any>TeacherPaymentsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
